<template> </template>

<script>
import Cookies from "js-cookie";
import parseDomain from "parse-domain";
export default {
  name: "SocialLogin",
  mounted() {
    this.$store.commit("showSpinner");
    this.socialLogin();
  },
  methods: {
    socialLogin() {
      let queryParametersFromSocial = this.$route.query;

      const campaignId = queryParametersFromSocial.state;

      const fanize_social_token = Cookies.get("fanize_social_token");

      const fanize_social_fallback = Cookies.get("fanize_social_fallback");

      if (fanize_social_token) {
        this.$http.defaults.headers.Authorization =
          "Bearer " + fanize_social_token;
      }

      this.$http
        .post(
          "/api/v1/campaigns/" +
            campaignId +
            "/users/" +
            this.$route.params.provider +
            "/socialLogin",
          {
            ...queryParametersFromSocial,
            ...{
              mgm: Cookies.get("mgm"),
              mgm_code: Cookies.get("mgm_code")
            }
          }
        )
        .then(response => {
          const parsedDomain = parseDomain(window.location.hostname);
          if (parsedDomain) {
            Cookies.remove("mgm", {
              domain: "." + parsedDomain.domain + "." + parsedDomain.tld
            });
            Cookies.remove("mgm_code", {
              domain: "." + parsedDomain.domain + "." + parsedDomain.tld
            });
            Cookies.set(
              "fanize_social_token",
              response.data.data.token.access_token,
              { domain: "." + parsedDomain.domain + "." + parsedDomain.tld }
            );
            window.location.replace(response.data.data.fqdn + "/dashboard");
          }
        })
        .catch(error => {
          const parsedDomain = parseDomain(window.location.hostname);
          Cookies.remove("fanize_social_fallback", {
            domain: "." + parsedDomain.domain + "." + parsedDomain.tld
          });
          window.location.replace("https://" + fanize_social_fallback);
        });
    }
  }
};
</script>
